export default __webpack_public_path__ + "static/media/whatsapp.359aed02.svg";